import React, { useEffect, useState } from 'react';
import styles from "../../asset/css/launchpadPage.module.css";
import Header from '../../components/global/Header';
import { Images } from '../../data/Images';
import { CiHeart } from "react-icons/ci";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { useNavigate, useParams } from 'react-router-dom';
import Usesale from '../../hooks/useSale';
import Usetoken from '../../hooks/useToken';
import { useSelector } from 'react-redux';
import { getallsalehook } from '../../actions/userAction';
import { LAMPORTS_PER_SOL } from '@solana/web3.js';
import Config from "../../config"
import { isEmpty } from '../../lib/isEmpty';
import { ImageComponent } from '../../components/global/ThemeImg';

export default function LaunchpadPage() {
  const navigate = useNavigate();

  const saleHook = Usesale()
  const params = useParams()
  const tokenHook = Usetoken()

  const [steps, setSteps] = useState(1);
  const [saleType, setSaleType] = useState("public");
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [wallet, setWallet] = useState(false)
  const [saleInfo, setSaleInfo] = useState({})
  const [saleDBInfo, setSaleDBInfo] = useState({})
  const [userData, setUserData] = useState({})
  const [max, setMax] = useState(0)
  const [isMax, setIsMax] = useState(false)
  const [amount, setAmount] = useState(0)
  const [saleAdd, setSaleAdd] = useState('')
  const [tokeninfo, setTokeninfo] = useState({})
  const [isbuy, setIsbuy] = useState(false)
  const [isclaim, setIsclaiming] = useState(false)
  const [isfinalize, setIsfinalize] = useState(false)
  const [userinfo, setUserinfo] = useState({})
  const [whitelistUserBuy, setwhitelistUserBuy] = useState(0)
  const [deposit, setDeposit] = useState(0)
  const [isdeposit, setIsdeposit] = useState(false)
  const [errors, setErrors] = useState({})
  const [buy, setBuy] = useState(false)
  const [status, setStatus] = useState(true);
  const [remainingbuyAmount, setremainingbuyAmount] = useState(0);
  const [walletAddress, setwalletAddress] = useState(sessionStorage.getItem("walletAddress"))
  const walletdetail = useSelector((state) => state.wallet)
  const sliderContent = [
    {
      title: "METAMASK",
      imgSrc: Images.sliderImg1
    },
    {
      title: "HANTOM",
      imgSrc: Images.sliderImg2
    },
    {
      title: "BINANCE",
      imgSrc: Images.sliderImg3
    },
    {
      title: "COIN CHECK",
      imgSrc: Images.sliderImg4
    },
    {
      title: "OPTIMISM",
      imgSrc: Images.sliderImg5
    },
    {
      title: "COIN BASE",
      imgSrc: Images.sliderImg6
    },
    {
      title: "SOLANA",
      imgSrc: Images.sliderImg7
    },
    {
      title: "ARBITRUM",
      imgSrc: Images.sliderImg8
    },

  ]


  useEffect(() => {
    setwalletAddress(sessionStorage.getItem("walletAddress"))
    getSaleData()

    console.log("walletdetail>>>>>", walletdetail);

  }, [walletdetail?.walletaddress])

  const getSaleData = async () => {

    let datas = await saleHook?.UseSaleInfo(params?.saleAddress)
    setSaleAdd(params?.saleAddress)
    setSaleInfo(datas)


    const getSalefromDb = await getallsalehook()
    console.log("getSalefromDb", getSalefromDb?.data?.data);

    const data = getSalefromDb?.data?.data;
    let DBData = {}
    if (data?.length > 0) {
      DBData = data?.find((val) => (val?.saleAddress == params?.saleAddress))
    }
    console.log("DBDataDBData", DBData);

    setSaleDBInfo(DBData)
  }

  var percentage = saleInfo && parseInt(parseInt(saleInfo?.currencyRaised / LAMPORTS_PER_SOL) / parseInt(saleInfo?.softCap / LAMPORTS_PER_SOL) * 100)

  return (
    <div className={`homePagelayout ${styles.LaunchpadPage}`}>
      <Header />
      <div className={styles.bodyContentPart}>
        {/* <section className={styles.sliderContainer}>
          <div className={styles.hotBtn}>
            <img src={Images.sliderHotImg} alt="Hot" />
            <p>Hot</p>
          </div>
          {sliderContent.map((item, i) => (
            <div key={i} className={styles.sliderBox}>
              <img src={item.imgSrc} alt="image" />
              <p>{item.title}</p>
            </div>
          ))
          }
        </section> */}
        <section className={styles.exploreWrapper}>
          {saleDBInfo && saleDBInfo.saleAddress ?
            <div className={styles.exploreCardContainer}>
              <div className={styles.headerPart}>
                <div className={styles.topImage}>
                  <img src={Images.cardBgImg} alt="image" />
                </div>
                <div className={styles.bottomSection}>
                  <div className={styles.leftPart}>
                    <img src={saleDBInfo?.logo ? saleDBInfo?.logo : Images.cardCoinImg} alt="coin" />
                    <div>
                      <h3>  {saleDBInfo?.name ? saleDBInfo?.name : 'Nexus'}

                      </h3>
                      <p>Max contribution: {saleInfo && saleInfo?.maximumBuy / LAMPORTS_PER_SOL}  {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                        saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                          saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}</p>
                    </div>
                  </div>
                  <div className={styles.rightPart}>
                    <button>
                      <img src={Images.cardSymbolImg} alt="" />
                    </button>
                  </div>
                </div>
              </div>
              <div className={styles.bodyPartAndFooterPart}>
                <div className={styles.bodyPart}>
                  <div className={styles.progressInputContainer}>
                    <label htmlFor="">Progress <span>{saleInfo?.currencyRaised ? `${(saleInfo && percentage > 100 ? 100 : parseInt((saleInfo?.currencyRaised / LAMPORTS_PER_SOL) / (saleInfo?.softCap / LAMPORTS_PER_SOL) * 100))} %` : "0 %"}
                    </span>
                      {/* <span><AiOutlineInfoCircle /></span>  */}
                    </label>
                    <input type="range"
                      value={saleInfo && percentage > 100 ? 100 : parseInt((saleInfo?.currencyRaised / LAMPORTS_PER_SOL) / (saleInfo?.softCap / LAMPORTS_PER_SOL) * 100)} />
                  </div>
                  <div className={styles.progressLists}>
                    <ul>
                      <li>
                        <p>Softcap</p>
                        <span>{saleInfo?.softCap / LAMPORTS_PER_SOL}{" "} {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" : "USDT"}</span>
                      </li>
                      {/* <li>
                      <p>Hardcap</p>
                      <span>{saleInfo?.hardCap / LAMPORTS_PER_SOL}{" "}
                        {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" : "USDT"}</span>
                    </li> */}

                      <li>
                        <p>Min Buy </p>
                        <span>{saleInfo && saleInfo?.minimumBuy / LAMPORTS_PER_SOL} {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                          saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                            saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}</span>
                      </li>
                      <li>
                        <p>Sale Type</p>
                        <span>{saleInfo?.isWhitelist == false ? 'Public' : 'Private'}
                        </span>
                      </li>
                      <li>
                        <p>Invest</p>
                        <span> {userinfo && !isEmpty(userinfo?.userInvested) ? (parseInt(userinfo?.userInvested) / LAMPORTS_PER_SOL) : 0}  {saleInfo?.buyMint?.toString() == Config?.SOL ? "SOL" :
                          saleInfo?.buyMint?.toString() == Config?.USDT ? "USDT" :
                            saleInfo?.buyMint?.toString() == Config?.USDC ? "USDC" : "DAI"}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <hr />
                <div className={styles.footerPart}>
                  <h2>The Sale is {saleInfo && saleHook.isUpcoming(parseInt(saleInfo?.presaleStart)) ? "Coming up" :
                    saleInfo && saleInfo.ready !== 2 && saleHook.isSaleLive(saleInfo.presaleStart, saleInfo.presaleEnd) ? "Live"
                      : saleInfo.ready == 2 || saleHook.isSaleEnded(parseInt(saleInfo?.presaleStart), parseInt(saleInfo?.presaleEnd)) ?

                        "Closed"
                        : <></>
                  }</h2>
                  <div className={"d-flex"}>
                    <button className='primaryBtn' onClick={() => navigate(`/launchpad-details/${localStorage.getItem("saleaddress")}`)}>Explore</button>
                  </div>
                </div>
              </div>
            </div>
            : <h2 className='noDataText  text-white'>No sale Available now</h2>}
        </section>
        <section className={styles.whyRubixSection}>
          <div className={styles.imgPart}>
            <ImageComponent staticImgSrc={"rubix_whyImg"} />
          </div>
          <div className={styles.contentPart}>
            <h2>Why Rubix?</h2>
            <h3>Rubix is the First Cross-Chain Digital Currency for the Digital Economy: </h3>
            <div>
              <h4>Store of Value:</h4>
              <p>A deflationary model ensures that Rubix can serve as a reliable asset for preserving wealth.</p>
            </div>
            <div>
              <h4>Medium of Exchange:</h4>
              <p>Rubix facilitates seamless transactions across multiple blockchains, making it a
                universal currency for decentralized applications.</p>
            </div>
            <div>
              <h4>Unit of Account:</h4>
              <p>Designed to be a standard measurement of value within the ecosystem, Rubix and Rubies simplifies financial interactions for users globally.</p>
            </div>
          </div>
        </section>
        <section className={styles.whyRubixSection}>
          <div className={styles.contentPart}>
            <h2>What makes Rubix so unique?</h2>
            <div>
              <h4>Community-Driven:</h4>
              <p>No team tokens or centralized control, Rubix prioritizes decentralization and fairness.</p>
            </div>
            <div>
              <h4>Medium of Exchange:</h4>
              <p>Rubix facilitates seamless transactions across multiple blockchains, making it a
                universal currency for decentralized applications.</p>
            </div>
            <div>
              <h4>Unit of Account:</h4>
              <p>Designed to be a standard measurement of value within the ecosystem, Rubix and Rubies simplifies financial interactions for users globally.</p>
            </div>
          </div>
          <div className={styles.imgPart}>
            <ImageComponent staticImgSrc={"uniqueImgGif"} />
          </div>
        </section>
        <section className={styles.liveTokenSection}>
          <div className={styles.leftPart}>
            <div>
              <h2>Live Token Sale </h2>
              <p>
                RUBIX (Rubix): Digital Currency for Everyone, Better Money for the World.
              </p>
              <p>Goal: Raise 200,000 USDC for adding liquidity on Dex's (Raydium) Rubix Dex</p>
            </div>
            <div className={styles.chatImgContainer}>
              <div className={styles.progressBarOuter}>
                <div className={styles.progressBarInner} style={{ width: "20%" }}>
                </div>
              </div>
              <div className={styles.marker + " " + styles.marker1}>
                <ImageComponent staticImgSrc={"lineImg"} />
                <p>Token Price: $.001</p>
              </div>
              <div className={styles.marker + " " + styles.marker2}>
                <p>Pool Size: 200,000,0000 $Rubix Tokens</p>
                <ImageComponent staticImgSrc={"lineImg"} />
              </div>
              <div className={styles.marker + " " + styles.marker3}>
                <p>Hardcap: 200,000 USDC</p>
                <ImageComponent staticImgSrc={"lineImg"} />
              </div>
              {/* <ImageComponent staticImgSrc={"liveTokenSalesChart"} /> */}
            </div>
          </div>
          <div className={styles.rightPart}>
            <ImageComponent staticImgSrc={"liveTokenImg"} />
          </div>
        </section>
        <section className={styles.aboutRubixSection}>
          <div className={styles.contentWrapper}>
            <div className={styles.leftPart}>
              <h3>About Rubix</h3>
              <p>
                Rubix is a cross-chain decentralized digital currency designed for the future of money. Built for Web3 and fintech, it powers seamless transactions, smart payments, and financial growth. With secure, borderless, and trustless value exchange, Rubix enables a more efficient and decentralized financial ecosystem worldwide.
              </p>
            </div>
            <div className={styles.rightPart}>
              <ImageComponent staticImgSrc={"aboutRubixImg"} />
            </div>
          </div>
          <div className={styles.rubixWorldImg}>
            <ImageComponent staticImgSrc={"rubixWorldImg"} />
          </div>
        </section>
        <section className={styles.rubixTokenomicSection}>
          <div className={styles.titlePart}>
            <h2>TOKENOMICS</h2>
            <p>Type :  Fair public launch Model: No team tokens, No pre-sale, no VC funding. </p>
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.leftContentPart}>
              <div className={styles.topText}>
                <ImageComponent staticImgSrc={"rubixTokenIcon1"} />
                <div>
                  <h2>Total Supply</h2>
                  <p>1,000,000,000</p>
                </div>
              </div>
            </div>
            <div className={styles.centerLogoPart}>
              <ImageComponent staticImgSrc={"rubixCenterLogo"} />
            </div>
            <div className={styles.rightContentPart}>
              <div className={styles.topText}>
                <ImageComponent staticImgSrc={"rubixTokenIcon2"} />
                <div>
                  <h2>Circulating Supply</h2>
                  <p>1,000,000,000</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.liquidityRewardsSection}>
          <div className={styles.titlePart}>
            <h2>
              Burning Mechanism & Liquidity Rewards:
            </h2>
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.chartImg}>
              <ImageComponent staticImgSrc={"liquidityRewardsChartImg"} />
            </div>
            <div className={styles.pointContent}>
              <ul>
                <li>
                  <span></span>
                  <p>2% sell tax on Rubix Dex: Applies when selling Rubix Tokens</p>
                </li>
                <li>
                  <span></span>
                  <p>1% for Rubix Token Burns: Automatically burns through smart contracts, reducing supply and increasing scarcity.
                  </p>
                </li>
                <li>
                  <span></span>
                  <p>1% for Liquidity Rewards: Distributes USDC as rewards to liquidity providers.</p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className={styles.modelUseCaseSection}>
          <div className={styles.titlePart}>
            <h2>
              Token Model Use Cases
            </h2>
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.stepModelCard}>
              <h2>1</h2>
              <div>
                <h3>
                  Spend Rubix:
                </h3>
                <p>
                  Use Rubix for purchases, tips, and everyday transactions instantly &amp; free.
                </p>
              </div>
            </div>
            <div className={styles.stepModelCard}>
              <h2>2</h2>
              <div>
                <h3>
                  Spend Rubix:
                </h3>
                <p>
                  Transfer Money globally without fees or delays.
                </p>
              </div>
            </div>
            <div className={styles.stepModelCard}>
              <h2>3</h2>
              <div>
                <h3>
                  Save in Rubix:
                </h3>
                <p>
                  Collateralize Rubix tokens to receive USDC for spending or saving.
                </p>
              </div>
            </div>
            <div className={styles.stepModelCard}>
              <h2>4</h2>
              <div>
                <h3>
                  Earn in Rubix:
                </h3>
                <p>
                  Stake, lend, or receive cashback on transactions to earn rewards.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.rubixLaunchpadSection}>
          <div className={styles.rubixCard}>
            <div className={styles.headerPart}>
              <ImageComponent staticImgSrc={"rubixLaunchpadIcon1"} />
            </div>
            <div className={styles.bodyPart}>
              <h3>Rubix DeFi:</h3>
              <p>Rubix DeFi is a unified decentralized finance (DeFi) platform built on Solana, offering powerful financial tools that enable users to earn, borrow, and grow their assets with ease.
              </p>
              <p>
                <strong>Bridge:</strong> Easily bridge Rubix Tokens across Solana, Ethereum and EVM Chains
                using wormhole technology.
              </p>

            </div>
            <div className={styles.footerPart}>
              <button>
                ReadMore <ImageComponent staticImgSrc={"downArrowIcon"} />
              </button>
            </div>
          </div>
          <div className={styles.rubixCard}>
            <div className={styles.headerPart}>
              <ImageComponent staticImgSrc={"rubixLaunchpadIcon2"} />
            </div>
            <div className={styles.bodyPart}>
              <h3>Rubix SocialFi:</h3>
              <p>Rubix is tailored for SocialFi apps enabling creators and users to interact and transact in
                new and engaging ways.
              </p>
              <ul>
                <li>
                  Micropayments for Digital Content
                </li>
                <li>
                  Tip Creators
                </li>
                <li>
                  Pay for premium memberships
                </li>
              </ul>
            </div>
            <div className={styles.footerPart}>
              <button>
                ReadMore <ImageComponent staticImgSrc={"downArrowIcon"} />
              </button>
            </div>
          </div>
          <div className={styles.rubixCard}>
            <div className={styles.headerPart}>
              <ImageComponent staticImgSrc={"rubixLaunchpadIcon3"} />
            </div>
            <div className={styles.bodyPart}>
              <h3>Rubix GameFi:</h3>
              <p>
                Rubix integrates seamlessly with GameFi platforms powering both player rewards and
                in-game economies.
              </p>
              <ul>
                <li>
                  Purchase In-game Assets (Digital items, characters, upgrades)
                </li>
                <li>
                  Earn Rubix in games by completing levels, or unlocking achievements
                </li>
              </ul>
            </div>
            <div className={styles.footerPart}>
              <button>
                ReadMore <ImageComponent staticImgSrc={"downArrowIcon"} />
              </button>
            </div>
          </div>
          <div className={styles.rubixCard}>
            <div className={styles.headerPart}>
              <ImageComponent staticImgSrc={"rubixLaunchpadIcon4"} />
            </div>
            <div className={styles.bodyPart}>
              <h3>Rubix AI - AgentFi:</h3>
              <p>
                - Rubix is at the forefront of the AI revolution, empowering Ai Agents to participate
                in the digital economy.
              </p>
              <ul>
                <li>
                  Human to AI Agent Payments: Use Rubix to pay Agents to complete tasks.
                </li>
              </ul>
            </div>
            <div className={styles.footerPart}>
              <button>
                ReadMore <ImageComponent staticImgSrc={"downArrowIcon"} />
              </button>
            </div>
          </div>
          <div className={styles.rubixCard}>
            <div className={styles.headerPart}>
              <ImageComponent staticImgSrc={"rubixLaunchpadIcon5"} />
            </div>
            <div className={styles.bodyPart}>
              <h3>Operated by Ruby:</h3>
              <p>
                The AI Agent behind Rubix. Ruby, our AI powered agent, is the face and voice of Rubix social platforms, including X, Discord, and telegram. Designed to foster connection within the community.
              </p>
              <ul>
                <li>
                  Content creation & updates
                </li>
              </ul>
            </div>
            <div className={styles.footerPart}>
              <button>
                ReadMore <ImageComponent staticImgSrc={"downArrowIcon"} />
              </button>
            </div>
          </div>
        </section>
      </div>
      <div className={styles.lanunchpadBgPatten}>
        {[...Array(22)].map((_dummy, index) => (
          <ImageComponent
            staticImgSrc={`launchpadPatten${index + 1}`}
            moduleStyle={styles}
            moduleClass={`launchpadCircleIcon-${index + 1}`} />
        ))}
        {/* <img className={styles.launchpadCircle1Icon} src={Images.launchpadCircle1Icon} alt="circle Shape" />
        <img className={styles.launchpadCircle2Icon} src={Images.launchpadCircle2Icon} alt="circle Shape" />
        <img className={styles.launchpadCircle3Icon} src={Images.launchpadCircle3Icon} alt="circle Shape" />
        <img className={styles.launchpadCircle4Icon} src={Images.launchpadCircle4Icon} alt="circle Shape" />
        <img className={styles.launchpadCircle5Icon} src={Images.launchpadCircle5Icon} alt="circle Shape" />
        <img className={styles.launchpadCircle6Icon} src={Images.launchpadCircle6Icon} alt="circle Shape" />
        <img className={styles.launchpadCircle7Icon} src={Images.launchpadCircle7Icon} alt="circle Shape" />
        <img className={styles.launchpadCircle8Icon} src={Images.launchpadCircle8Icon} alt="circle Shape" /> */}
      </div>
    </div>
  )
}
